import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import UnifiedProfileExperienceEntry from './UnifiedProfileExperienceEntry'
import UnifiedProfileAchievement from './UnifiedProfileAchievement'

export default class UnifiedProfileExperience extends BaseModel {
  static override constructorName = 'UnifiedProfileExperienceModel'

  experience: UnifiedProfileExperienceEntry[] = []
  relocation: boolean = false
  'with_lodging': boolean = false
  'metro_station': string | null = null
  'street_of_residence': string | null = null
  achievements: UnifiedProfileAchievement[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.experience = Array.isArray(data.experience)
        ? data.experience.map(item => new UnifiedProfileExperienceEntry(item))
        : []

      this.achievements = Array.isArray(data.achievements)
        ? data.achievements.map(item => new UnifiedProfileAchievement(item))
        : []
    }
  }
}

registerModel(UnifiedProfileExperience)
